import { EMAIL_REGEX, CW_EMAIL_REGEX } from './regex'

export const isValidEmail = (value) =>
  !!EMAIL_REGEX.test(value) && !CW_EMAIL_REGEX.test(value)
